import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#3C0D44',
        error: '#EF5553',
        background: 'rgb(246, 249, 252)'
      }
    }
  }
});
